// CollapseFilterDrawer.jsx
import React, { useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Button, Collapse, Col, Row, Form, Badge, Tooltip } from "antd";
import LangContext, { i18n } from "modules/shared/context/langContext";
import { checkPermissions } from "../../../lib/helper";

const { Panel } = Collapse;

const CollapseFilterDrawer = ({
  header = (
    <LangContext.Consumer>{(i18n) => i18n.s.search}</LangContext.Consumer>
  ),
  filters = [],
  onReset,
  onSubmit,
  onAdd = false,
  onFilter = false,
}) => {
  const [activeKey, setActiveKey] = useState(["1"]);

  const checkSpan = (filters) => {
    if (filters.length === 0) return 24;
    return 24 % filters.length === 0
      ? 24 / filters.length
      : Math.floor(24 / filters.length);
  };
  const span = checkSpan(filters);

  const handleCloseCollapse = () => {
    if (activeKey.length > 0) {
      setActiveKey([]);
    } else {
      setActiveKey(["1"]);
    }
  };

  {
    if (!filters || filters.length === 0) {
      return null;
    }

    if (filters.length === 1) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: "4px",
            marginBottom: "8px",
          }}
        >
          <div style={{ width: "30%" }}>
            <Form.Item
              label={filters[0].label}
              validateStatus={filters[0].validateStatus}
              help={filters[0].help}
              style={{ marginBottom: 0 }}
            >
              {filters[0].child}
            </Form.Item>
          </div>
          <div>
            {onAdd &&
              checkPermissions(
                onAdd.permission,
                onAdd.matchingName,
                onAdd.matchingName2
              ) && (
                <Link to={onAdd.path}>
                  <Tooltip placement="left" title={onAdd.tips}>
                    <Button
                      type="primary"
                      icon={onAdd.icon}
                      style={{ marginLeft: "4px" }}
                    />
                  </Tooltip>
                </Link>
              )}
            {onFilter && onFilter}
          </div>
        </div>
      );
    }

    return (
      <Collapse
        activeKey={activeKey}
        style={{ marginBottom: 12 }}
        onChange={(activeKey) => setActiveKey(activeKey)}
      >
        <Panel header={header} key="1">
          <Form layout="vertical" style={{ padding: "4px" }}>
            <Row
              gutter={[16, 0]}
              style={{ margin: 0 }}
              type="flex"
              justify="center"
              align="bottom"
            >
              {filters.map((filter, index) => (
                <Col key={index} xs={24} sm={24} md={span} lg={span} xl={span}>
                  <Form.Item
                    label={filter.label}
                    validateStatus={filter.validateStatus}
                    help={filter.help}
                  >
                    {filter.child}
                  </Form.Item>
                </Col>
              ))}
            </Row>

            <Row
              gutter={[16, 8]}
              style={{ margin: 0, marginTop: 16 }}
              type="flex"
              justify="end"
            >
              <Col>
                <Button
                  type="default"
                  style={{ marginRight: 8 }}
                  onClick={onReset}
                >
                  <LangContext.Consumer>
                    {(i18n) => i18n.r.reset}
                  </LangContext.Consumer>
                </Button>
                <Button type="primary" onClick={onSubmit}>
                  <LangContext.Consumer>
                    {(i18n) => i18n.a.apply}
                  </LangContext.Consumer>
                </Button>
              </Col>
            </Row>
          </Form>
        </Panel>
      </Collapse>
    );
  }
};;

export default connect(
  ({ auth, ui: { language } }) => ({ auth, language }),
  {}
)(CollapseFilterDrawer);
